import { BreadcrumbJsonLd } from 'next-seo';
import PropTypes from 'prop-types';

import { getCategoryBreadcrumbArr } from 'lib/schema';

const CategorySchema = ({
  categoryName,
  categorySlug,
  deepSubcategoryName = null,
  deepSubcategorySlug = null,
  subcategoryName = null,
  subcategorySlug = null,
}) => (
  <BreadcrumbJsonLd
    itemListElements={getCategoryBreadcrumbArr({
      categoryName,
      categorySlug,
      subcategoryName,
      subcategorySlug,
      deepSubcategoryName,
      deepSubcategorySlug,
    })}
  />
);

CategorySchema.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  deepSubcategoryName: PropTypes.string,
  deepSubcategorySlug: PropTypes.string,
  subcategoryName: PropTypes.string,
  subcategorySlug: PropTypes.string,
};

export default CategorySchema;
